import React, { FC } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { DEVICE_PLACEHOLDERS, DEVICE_RENAME, hidenCollectionsIds } from 'config';

import { RatingSummary, Screenshot } from '../../types/app';
import { Link } from '../Common';
import { OneStarRating } from './Rating/OneStarRating';
import { BannerContainer } from './ImageContainer/BannerContainer';
import { fontSemibold } from '../../themes';

import installedCheck from 'inline-icons/circle-check-v2.svg';

const DEVICES: any = DEVICE_PLACEHOLDERS;
const RENAME: any = DEVICE_RENAME;

type ReduxProps = ReturnType<typeof mapStateToProps>;

interface ClockCardProps extends ReduxProps {
  id: string;
  rating: RatingSummary;
  screenshot: Screenshot;
  name: string;
  showRatings: boolean;
  isPremium: boolean;
  isInstalled: boolean;
  deviceName: string;
  collectionId?: string;
  onClick?: () => void;
}

const Ratings = styled.div`
  justify-content: space-evenly;
  padding: 2px 20px;
  display: flex;
`;

const InstalledIconContainer = styled.div`
  position: absolute;
  bottom: -7px;
  height: 22px;
  width: 22px;
`;

const InstalledIcon = styled(InstalledIconContainer).attrs({
  dangerouslySetInnerHTML: { __html: installedCheck }
})``;

const Name = styled.div`
  font-family: ${fontSemibold};
  padding: 5px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
`;

const Container = styled.div<any>`
  display: flex;
  justify-content: center;
  align-content: center;
  ${({ premiumClockIcon }) => premiumClockIcon ?
    `background: url(${premiumClockIcon}) center center / contain no-repeat;` :
    ''
  }
  position: relative;
`;

const ClockCard: FC<ClockCardProps> = ({
  id,
  screenshot,
  name,
  rating,
  showRatings,
  isPremium,
  deviceName,
  collectionId,
  onClick,
  isInstalled,
  gregEnabled,
  optimizelyUser
}) => {
  let premiumClockIcon;
  if (isPremium) {
    premiumClockIcon = DEVICES[deviceName]?.premiumClockIcon;
  }

  const queryParam = collectionId ? `?collectionId=${collectionId}` : '';
  
  return (
    <div>
      <Link
        to={`/v2/clock/${id}${queryParam}`}
        pageDirection="FORWARD"
        className="clock-link"
        id={id}
        aria-label={id}
        onClick={() => {
          if ( gregEnabled && collectionId && hidenCollectionsIds.includes(collectionId) && optimizelyUser ) {
            optimizelyUser.trackEvent('greg_app_open');
          }
          onClick && onClick()
        }}
      >
        <Container premiumClockIcon={premiumClockIcon}>
          <BannerContainer
            containerAttr={{
              width: screenshot.width,
              height: screenshot.height,
            } as any}
            imageAttr={{
              src: screenshot.uri,
              alt: name,
            }}
          />
          {isInstalled && <InstalledIcon id={`${id}-installed-icon`} aria-label={`${id}-installed-icon`} />}
        </Container>
        <Name>{name}</Name>
        <Ratings>
          { showRatings && <OneStarRating rating={rating} /> }
        </Ratings>
      </Link>
    </div>
  );
}

const mapStateToProps = (state: any) => {
  const deviceName = state.registry.currentUser.device?.productName?.toLowerCase();

  const galleryState = state.gallery;
  const { gregEnabled, userContext } = galleryState.experiments;

  return {
    deviceName: RENAME[deviceName] || deviceName,
    gregEnabled,
    optimizelyUser: userContext
  }
};

const ConnectedClockCard = connect(mapStateToProps)(ClockCard);

export {ConnectedClockCard as ClockCard};
